<template>
    <Form ref="defaultForm" :validation-schema="getSchema()">
        <div class="flex items-center  xl:flex-row flex-col gap-3 mt-3 mb-3">   
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="variantName" v-model="form.variantName">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Variant Size/Name</label>
                        <input @change="vm_modified(true)" v-bind="field" placeholder="3.5g" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>

            <div class="w-full xl:w-1/3">
                <Field v-slot="{field, errors, errorMessage}" name="dryCannabisEquivalency" v-model="form.dryCannabisEquivalency">
                    <label class="text-xs">Cart Equivalency</label>
                    <div v-if="editItem.complianceType && editItem.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                    <input v-else @change="vm_modified(true)" v-bind="field" placeholder="1-4" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                    <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                    <div v-else class="text-xs">&nbsp;</div>
                </Field>
            </div>
            <div class="w-full xl:w-1/3" v-if="vg_selectedLocation.id">
                <div class="input-wrapper">
                    <Field type="checkbox" v-slot="{field}" name="thc_cbd_value_type" v-model="form.thc_cbd_value_type" value="range" unchecked-value="single">
                        <span class="text-white text-xs font-normal"> THC/CBD Values </span>
                        <label for="item-range" class="flex items-center cursor-pointer ">
                            <span class="mr-2 text-white text-sm tracking-wider"> Single </span>
                            <input @change="vm_modified(true)" v-bind="field" value="range" type="checkbox" id="item-range" class="hidden peer">
                            <div class="w-12 h-6 bg-gray-400 peer-focus:outline-none peer-focus:ring-4 
                            peer-focus:ring-theme-green dark:peer-focus:ring-theme-green relative rounded-full peer 
                            dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] 
                            after:absolute  after:bg-white after:border-gray-400 after:border after:rounded-full 
                            after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-theme-green"></div>
                            <span class="ml-2 text-white text-sm text-theme-878686 tracking-wider"> Range </span>
                        </label>
                    </Field>
                </div>
            </div>
        </div>
        <div class="flex gap-3 xl:flex-row flex-col items-start mb-3" v-if="vg_selectedLocation.id">
            <div class="w-full xl:w-1/4">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="cost" v-model="form.cost">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Cost</label>
                        <span class="absolute top-[33px] left-3">
                            <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.88281 0.820312V3.125H3.66406V0.820312H4.88281ZM4.73438 13.5781V15.6797H3.51562V13.5781H4.73438ZM5.59375 11.0156C5.59375 10.7188 5.53906 10.4661 5.42969 10.2578C5.32552 10.0495 5.15365 9.86458 4.91406 9.70312C4.67969 9.54167 4.36198 9.38542 3.96094 9.23438C3.28385 8.97396 2.6875 8.69792 2.17188 8.40625C1.66146 8.10938 1.26302 7.74219 0.976562 7.30469C0.690104 6.86198 0.546875 6.30208 0.546875 5.625C0.546875 4.97917 0.700521 4.41927 1.00781 3.94531C1.3151 3.47135 1.73958 3.10677 2.28125 2.85156C2.82812 2.59115 3.46354 2.46094 4.1875 2.46094C4.73958 2.46094 5.23958 2.54427 5.6875 2.71094C6.13542 2.8724 6.52083 3.11198 6.84375 3.42969C7.16667 3.74219 7.41406 4.125 7.58594 4.57812C7.75781 5.03125 7.84375 5.54948 7.84375 6.13281H5.60156C5.60156 5.82031 5.56771 5.54427 5.5 5.30469C5.43229 5.0651 5.33333 4.86458 5.20312 4.70312C5.07812 4.54167 4.92708 4.42188 4.75 4.34375C4.57292 4.26042 4.3776 4.21875 4.16406 4.21875C3.84635 4.21875 3.58594 4.28125 3.38281 4.40625C3.17969 4.53125 3.03125 4.70052 2.9375 4.91406C2.84896 5.1224 2.80469 5.36198 2.80469 5.63281C2.80469 5.89844 2.85156 6.13021 2.94531 6.32812C3.04427 6.52604 3.21354 6.70833 3.45312 6.875C3.69271 7.03646 4.02083 7.20312 4.4375 7.375C5.11458 7.63542 5.70833 7.91667 6.21875 8.21875C6.72917 8.52083 7.1276 8.89062 7.41406 9.32812C7.70052 9.76562 7.84375 10.3229 7.84375 11C7.84375 11.6719 7.6875 12.2448 7.375 12.7188C7.0625 13.1875 6.625 13.5469 6.0625 13.7969C5.5 14.0417 4.84896 14.1641 4.10938 14.1641C3.63021 14.1641 3.15365 14.1016 2.67969 13.9766C2.20573 13.8464 1.77604 13.638 1.39062 13.3516C1.00521 13.0651 0.697917 12.6849 0.46875 12.2109C0.239583 11.7318 0.125 11.1432 0.125 10.4453H2.375C2.375 10.8255 2.42448 11.1432 2.52344 11.3984C2.6224 11.6484 2.7526 11.849 2.91406 12C3.08073 12.1458 3.26823 12.25 3.47656 12.3125C3.6849 12.375 3.89583 12.4062 4.10938 12.4062C4.44271 12.4062 4.71615 12.3464 4.92969 12.2266C5.14844 12.1068 5.3125 11.9427 5.42188 11.7344C5.53646 11.5208 5.59375 11.2812 5.59375 11.0156Z" fill="white"/>
                            </svg>
                        </span>
                        <input @keyup="vm_modified(true)" @wheel.prevent v-model="form.cost" name="cost" placeholder="39.99" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686 pl-6" type="number">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
             <div class="w-full xl:w-1/4">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="price" v-model="form.price">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Regular Price</label>
                        <span class="absolute top-[33px] left-3">
                            <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.88281 0.820312V3.125H3.66406V0.820312H4.88281ZM4.73438 13.5781V15.6797H3.51562V13.5781H4.73438ZM5.59375 11.0156C5.59375 10.7188 5.53906 10.4661 5.42969 10.2578C5.32552 10.0495 5.15365 9.86458 4.91406 9.70312C4.67969 9.54167 4.36198 9.38542 3.96094 9.23438C3.28385 8.97396 2.6875 8.69792 2.17188 8.40625C1.66146 8.10938 1.26302 7.74219 0.976562 7.30469C0.690104 6.86198 0.546875 6.30208 0.546875 5.625C0.546875 4.97917 0.700521 4.41927 1.00781 3.94531C1.3151 3.47135 1.73958 3.10677 2.28125 2.85156C2.82812 2.59115 3.46354 2.46094 4.1875 2.46094C4.73958 2.46094 5.23958 2.54427 5.6875 2.71094C6.13542 2.8724 6.52083 3.11198 6.84375 3.42969C7.16667 3.74219 7.41406 4.125 7.58594 4.57812C7.75781 5.03125 7.84375 5.54948 7.84375 6.13281H5.60156C5.60156 5.82031 5.56771 5.54427 5.5 5.30469C5.43229 5.0651 5.33333 4.86458 5.20312 4.70312C5.07812 4.54167 4.92708 4.42188 4.75 4.34375C4.57292 4.26042 4.3776 4.21875 4.16406 4.21875C3.84635 4.21875 3.58594 4.28125 3.38281 4.40625C3.17969 4.53125 3.03125 4.70052 2.9375 4.91406C2.84896 5.1224 2.80469 5.36198 2.80469 5.63281C2.80469 5.89844 2.85156 6.13021 2.94531 6.32812C3.04427 6.52604 3.21354 6.70833 3.45312 6.875C3.69271 7.03646 4.02083 7.20312 4.4375 7.375C5.11458 7.63542 5.70833 7.91667 6.21875 8.21875C6.72917 8.52083 7.1276 8.89062 7.41406 9.32812C7.70052 9.76562 7.84375 10.3229 7.84375 11C7.84375 11.6719 7.6875 12.2448 7.375 12.7188C7.0625 13.1875 6.625 13.5469 6.0625 13.7969C5.5 14.0417 4.84896 14.1641 4.10938 14.1641C3.63021 14.1641 3.15365 14.1016 2.67969 13.9766C2.20573 13.8464 1.77604 13.638 1.39062 13.3516C1.00521 13.0651 0.697917 12.6849 0.46875 12.2109C0.239583 11.7318 0.125 11.1432 0.125 10.4453H2.375C2.375 10.8255 2.42448 11.1432 2.52344 11.3984C2.6224 11.6484 2.7526 11.849 2.91406 12C3.08073 12.1458 3.26823 12.25 3.47656 12.3125C3.6849 12.375 3.89583 12.4062 4.10938 12.4062C4.44271 12.4062 4.71615 12.3464 4.92969 12.2266C5.14844 12.1068 5.3125 11.9427 5.42188 11.7344C5.53646 11.5208 5.59375 11.2812 5.59375 11.0156Z" fill="white"/>
                            </svg>
                        </span>
                        <div>
                            <input :disabled="!can_manage_pricing_groups && havePricingGroup && !((!memoryPrice || memoryPrice=='null') && !!asn?.id)" @keyup="vm_modified(true)" @wheel.prevent v-model="form.price" @change="showPriceChangeWarning" name="price" placeholder=" 34.55" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686 pl-6" type="number">
                            <div v-if="!can_manage_pricing_groups && havePricingGroup && !((!memoryPrice || memoryPrice=='null') && !!asn?.id)">
                                <svg @click="togglePermissionWarning" class="absolute top-[32px] right-[3px] cursor-pointer" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.0001 14.168C10.2362 14.168 10.4341 14.0881 10.5938 13.9284C10.7536 13.7687 10.8334 13.5707 10.8334 13.3346V10.0013C10.8334 9.76519 10.7536 9.56728 10.5938 9.40755C10.4341 9.24783 10.2362 9.16797 10.0001 9.16797C9.76397 9.16797 9.56605 9.24783 9.40633 9.40755C9.24661 9.56728 9.16675 9.76519 9.16675 10.0013V13.3346C9.16675 13.5707 9.24661 13.7687 9.40633 13.9284C9.56605 14.0881 9.76397 14.168 10.0001 14.168ZM10.0001 7.5013C10.2362 7.5013 10.4341 7.42144 10.5938 7.26172C10.7536 7.102 10.8334 6.90408 10.8334 6.66797C10.8334 6.43186 10.7536 6.23394 10.5938 6.07422C10.4341 5.9145 10.2362 5.83464 10.0001 5.83464C9.76397 5.83464 9.56605 5.9145 9.40633 6.07422C9.24661 6.23394 9.16675 6.43186 9.16675 6.66797C9.16675 6.90408 9.24661 7.102 9.40633 7.26172C9.56605 7.42144 9.76397 7.5013 10.0001 7.5013ZM10.0001 18.3346C8.8473 18.3346 7.76397 18.1159 6.75008 17.6784C5.73619 17.2409 4.85425 16.6471 4.10425 15.8971C3.35425 15.1471 2.7605 14.2652 2.323 13.2513C1.8855 12.2374 1.66675 11.1541 1.66675 10.0013C1.66675 8.84853 1.8855 7.76519 2.323 6.7513C2.7605 5.73741 3.35425 4.85547 4.10425 4.10547C4.85425 3.35547 5.73619 2.76172 6.75008 2.32422C7.76397 1.88672 8.8473 1.66797 10.0001 1.66797C11.1529 1.66797 12.2362 1.88672 13.2501 2.32422C14.264 2.76172 15.1459 3.35547 15.8959 4.10547C16.6459 4.85547 17.2397 5.73741 17.6772 6.7513C18.1147 7.76519 18.3334 8.84853 18.3334 10.0013C18.3334 11.1541 18.1147 12.2374 17.6772 13.2513C17.2397 14.2652 16.6459 15.1471 15.8959 15.8971C15.1459 16.6471 14.264 17.2409 13.2501 17.6784C12.2362 18.1159 11.1529 18.3346 10.0001 18.3346ZM10.0001 16.668C11.8612 16.668 13.4376 16.0221 14.7292 14.7305C16.0209 13.4388 16.6667 11.8624 16.6667 10.0013C16.6667 8.14019 16.0209 6.5638 14.7292 5.27214C13.4376 3.98047 11.8612 3.33464 10.0001 3.33464C8.13897 3.33464 6.56258 3.98047 5.27092 5.27214C3.97925 6.5638 3.33341 8.14019 3.33341 10.0013C3.33341 11.8624 3.97925 13.4388 5.27092 14.7305C6.56258 16.0221 8.13897 16.668 10.0001 16.668Z" fill="white"/>
                                </svg>
                                <div v-if="showPermissionWarning" class="absolute bg-black p-[10px] text-white z-[99] rounded-l-md rounded-b-md text-[10px]">You do not have permission to edit prices for this pricing group. Please contact your admin to make pricing group updates, or change the sale price.</div>
                            </div>
                        </div>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else-if="(form.cost || form.cost===0)" class="text-xs capitalize">{{markupType?markupType:'Markup'}}: {{markupPercent==='error'?'error':markupPercent+'%'}}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
            <div class="w-full xl:w-1/4">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="sale_price" v-model="form.sale_price">
                        <label class="text-xs">Sale Price:</label>
                        <span class="absolute top-[33px] left-3">
                            <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.88281 0.820312V3.125H3.66406V0.820312H4.88281ZM4.73438 13.5781V15.6797H3.51562V13.5781H4.73438ZM5.59375 11.0156C5.59375 10.7188 5.53906 10.4661 5.42969 10.2578C5.32552 10.0495 5.15365 9.86458 4.91406 9.70312C4.67969 9.54167 4.36198 9.38542 3.96094 9.23438C3.28385 8.97396 2.6875 8.69792 2.17188 8.40625C1.66146 8.10938 1.26302 7.74219 0.976562 7.30469C0.690104 6.86198 0.546875 6.30208 0.546875 5.625C0.546875 4.97917 0.700521 4.41927 1.00781 3.94531C1.3151 3.47135 1.73958 3.10677 2.28125 2.85156C2.82812 2.59115 3.46354 2.46094 4.1875 2.46094C4.73958 2.46094 5.23958 2.54427 5.6875 2.71094C6.13542 2.8724 6.52083 3.11198 6.84375 3.42969C7.16667 3.74219 7.41406 4.125 7.58594 4.57812C7.75781 5.03125 7.84375 5.54948 7.84375 6.13281H5.60156C5.60156 5.82031 5.56771 5.54427 5.5 5.30469C5.43229 5.0651 5.33333 4.86458 5.20312 4.70312C5.07812 4.54167 4.92708 4.42188 4.75 4.34375C4.57292 4.26042 4.3776 4.21875 4.16406 4.21875C3.84635 4.21875 3.58594 4.28125 3.38281 4.40625C3.17969 4.53125 3.03125 4.70052 2.9375 4.91406C2.84896 5.1224 2.80469 5.36198 2.80469 5.63281C2.80469 5.89844 2.85156 6.13021 2.94531 6.32812C3.04427 6.52604 3.21354 6.70833 3.45312 6.875C3.69271 7.03646 4.02083 7.20312 4.4375 7.375C5.11458 7.63542 5.70833 7.91667 6.21875 8.21875C6.72917 8.52083 7.1276 8.89062 7.41406 9.32812C7.70052 9.76562 7.84375 10.3229 7.84375 11C7.84375 11.6719 7.6875 12.2448 7.375 12.7188C7.0625 13.1875 6.625 13.5469 6.0625 13.7969C5.5 14.0417 4.84896 14.1641 4.10938 14.1641C3.63021 14.1641 3.15365 14.1016 2.67969 13.9766C2.20573 13.8464 1.77604 13.638 1.39062 13.3516C1.00521 13.0651 0.697917 12.6849 0.46875 12.2109C0.239583 11.7318 0.125 11.1432 0.125 10.4453H2.375C2.375 10.8255 2.42448 11.1432 2.52344 11.3984C2.6224 11.6484 2.7526 11.849 2.91406 12C3.08073 12.1458 3.26823 12.25 3.47656 12.3125C3.6849 12.375 3.89583 12.4062 4.10938 12.4062C4.44271 12.4062 4.71615 12.3464 4.92969 12.2266C5.14844 12.1068 5.3125 11.9427 5.42188 11.7344C5.53646 11.5208 5.59375 11.2812 5.59375 11.0156Z" fill="white"/>
                            </svg>
                        </span>
                        <input @change="vm_modified(true)" @wheel.prevent v-model="form.sale_price" name="sale_price" placeholder="75" class="bg-gray-black border-none rounded text-sm  w-full pl-6 pr-[10px]" type="number">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else>
                            <div v-if="discountPercent()" class="text-xs flex">
                                <p class="mt-1 text-theme-878686">Discount: 
                                    <span class="text-white">{{discountPercent()}}%</span>
                                </p>
                                <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="mt-1 ml-2">
                                    <path d="M6.57812 9.625H7.51562V5.875H6.57812V9.625ZM7 4.71875C7.14583 4.71875 7.26823 4.67188 7.36719 4.57812C7.46615 4.48438 7.51562 4.36458 7.51562 4.21875C7.51562 4.07292 7.46615 3.94792 7.36719 3.84375C7.26823 3.73958 7.14583 3.6875 7 3.6875C6.85417 3.6875 6.73177 3.73958 6.63281 3.84375C6.53385 3.94792 6.48438 4.07292 6.48438 4.21875C6.48438 4.36458 6.53385 4.48438 6.63281 4.57812C6.73177 4.67188 6.85417 4.71875 7 4.71875ZM7 12.75C6.14583 12.75 5.33854 12.5859 4.57812 12.2578C3.81771 11.9297 3.15365 11.4818 2.58594 10.9141C2.01823 10.3464 1.57031 9.68229 1.24219 8.92188C0.914062 8.16146 0.75 7.34896 0.75 6.48438C0.75 5.63021 0.914062 4.82292 1.24219 4.0625C1.57031 3.30208 2.01823 2.64062 2.58594 2.07813C3.15365 1.51563 3.81771 1.07031 4.57812 0.742187C5.33854 0.414062 6.15104 0.25 7.01562 0.25C7.86979 0.25 8.67708 0.414062 9.4375 0.742187C10.1979 1.07031 10.8594 1.51563 11.4219 2.07813C11.9844 2.64062 12.4297 3.30208 12.7578 4.0625C13.0859 4.82292 13.25 5.63542 13.25 6.5C13.25 7.35417 13.0859 8.16146 12.7578 8.92188C12.4297 9.68229 11.9844 10.3464 11.4219 10.9141C10.8594 11.4818 10.1979 11.9297 9.4375 12.2578C8.67708 12.5859 7.86458 12.75 7 12.75ZM7.01562 11.8125C8.48437 11.8125 9.73438 11.2943 10.7656 10.2578C11.7969 9.22135 12.3125 7.96354 12.3125 6.48438C12.3125 5.01563 11.7969 3.76562 10.7656 2.73438C9.73438 1.70312 8.47917 1.1875 7 1.1875C5.53125 1.1875 4.27865 1.70312 3.24219 2.73438C2.20573 3.76562 1.6875 5.02083 1.6875 6.5C1.6875 7.96875 2.20573 9.22135 3.24219 10.2578C4.27865 11.2943 5.53646 11.8125 7.01562 11.8125Z" fill="white"/>
                                </svg>
                            </div>
                            <div v-if="calculateSaleMarkupMargin()" class="text-xs flex">
                                <p class="mt-1 capitalize">Sale {{markupType?markupType:'Markup'}}: 
                                    <span class="text-white">{{calculateSaleMarkupMargin()==='error'?'Error':calculateSaleMarkupMargin()+'%'}}</span>
                                </p>
                            </div>
                        </div>
                    </Field>
                </div>
            </div>
            <div class="w-full xl:w-1/4">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="onlineSalePrice" v-model="form.onlineSalePrice">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Online Sale Price</label>
                        <span class="absolute top-[33px] left-3">
                            <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.88281 0.820312V3.125H3.66406V0.820312H4.88281ZM4.73438 13.5781V15.6797H3.51562V13.5781H4.73438ZM5.59375 11.0156C5.59375 10.7188 5.53906 10.4661 5.42969 10.2578C5.32552 10.0495 5.15365 9.86458 4.91406 9.70312C4.67969 9.54167 4.36198 9.38542 3.96094 9.23438C3.28385 8.97396 2.6875 8.69792 2.17188 8.40625C1.66146 8.10938 1.26302 7.74219 0.976562 7.30469C0.690104 6.86198 0.546875 6.30208 0.546875 5.625C0.546875 4.97917 0.700521 4.41927 1.00781 3.94531C1.3151 3.47135 1.73958 3.10677 2.28125 2.85156C2.82812 2.59115 3.46354 2.46094 4.1875 2.46094C4.73958 2.46094 5.23958 2.54427 5.6875 2.71094C6.13542 2.8724 6.52083 3.11198 6.84375 3.42969C7.16667 3.74219 7.41406 4.125 7.58594 4.57812C7.75781 5.03125 7.84375 5.54948 7.84375 6.13281H5.60156C5.60156 5.82031 5.56771 5.54427 5.5 5.30469C5.43229 5.0651 5.33333 4.86458 5.20312 4.70312C5.07812 4.54167 4.92708 4.42188 4.75 4.34375C4.57292 4.26042 4.3776 4.21875 4.16406 4.21875C3.84635 4.21875 3.58594 4.28125 3.38281 4.40625C3.17969 4.53125 3.03125 4.70052 2.9375 4.91406C2.84896 5.1224 2.80469 5.36198 2.80469 5.63281C2.80469 5.89844 2.85156 6.13021 2.94531 6.32812C3.04427 6.52604 3.21354 6.70833 3.45312 6.875C3.69271 7.03646 4.02083 7.20312 4.4375 7.375C5.11458 7.63542 5.70833 7.91667 6.21875 8.21875C6.72917 8.52083 7.1276 8.89062 7.41406 9.32812C7.70052 9.76562 7.84375 10.3229 7.84375 11C7.84375 11.6719 7.6875 12.2448 7.375 12.7188C7.0625 13.1875 6.625 13.5469 6.0625 13.7969C5.5 14.0417 4.84896 14.1641 4.10938 14.1641C3.63021 14.1641 3.15365 14.1016 2.67969 13.9766C2.20573 13.8464 1.77604 13.638 1.39062 13.3516C1.00521 13.0651 0.697917 12.6849 0.46875 12.2109C0.239583 11.7318 0.125 11.1432 0.125 10.4453H2.375C2.375 10.8255 2.42448 11.1432 2.52344 11.3984C2.6224 11.6484 2.7526 11.849 2.91406 12C3.08073 12.1458 3.26823 12.25 3.47656 12.3125C3.6849 12.375 3.89583 12.4062 4.10938 12.4062C4.44271 12.4062 4.71615 12.3464 4.92969 12.2266C5.14844 12.1068 5.3125 11.9427 5.42188 11.7344C5.53646 11.5208 5.59375 11.2812 5.59375 11.0156Z" fill="white"/>
                            </svg>
                        </span>
                        <input @keyup="vm_modified(true)" @wheel.prevent v-model="form.onlineSalePrice" name="onlineSalePrice" placeholder="39.99" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686 pl-6" type="number">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else>
                            <div v-if="calculateSaleMarkupMargin('online')" class="text-xs flex">
                                <p class="mt-1 capitalize">Sale {{markupType?markupType:'Markup'}}: 
                                    <span class="text-white">{{calculateSaleMarkupMargin('online')==='error'?'Error':calculateSaleMarkupMargin('online')+'%'}}</span>
                                </p>
                            </div>
                        </div>
                    </Field>
                </div>
            </div>
        </div>

        <div class="flex gap-3 xl:flex-row flex-col items-start mb-3" v-if="vg_selectedLocation.id">
            <!-- single thc or range -->
            <div class="w-full xl:w-1/3" :class="(!form.thc_cbd_value_type || form.thc_cbd_value_type=='single')?'':'hidden'">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="thc" v-model.number="form.thc">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">THC</label>
                        <div v-if="editItem.complianceType && editItem.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                        <div v-else class="flex flex-row rounded bg-gray-black ">
                            <span class="mt-1 ml-2">{{form.concentration_unit}}</span>
                            <input @change="vm_modified(true)" v-model.number="form.thc" name="thc" placeholder="20.5" class="block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                        </div>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
            <!-- cbd is not set or cdb is range -->
            <div class="w-full xl:w-1/3" :class="(form.thc_cbd_value_type && form.thc_cbd_value_type=='range')?'':'hidden'">
                <div class="input-wrapper">
                    <label class="text-xs">THC ({{form.concentration_unit}})</label>
                    <div class="flex">
                        <div class="relative w-full">
                            <Field v-slot="{field, errors, errorMessage}" name="thc_min" v-model.number="form.thc_min">
                                <div v-if="editItem.complianceType && editItem.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                <input v-else @change="vm_modified(true)" v-model.number="form.thc_min" name="thc_min" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                        <span class="flex mt-4 mx-1">
                            <svg width="5" height="3" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.61719 0.955078V2.5H0.754883V0.955078H4.61719Z" fill="white"/>
                            </svg>
                        </span>
                        <div class="relative w-full">
                            <Field v-slot="{field, errors, errorMessage}" name="thc_max" v-model.number="form.thc_max">
                                <div v-if="editItem.complianceType && editItem.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                <input v-else @change="vm_modified(true)" v-model.number="form.thc_max" name="thc_max" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Single CBD or range -->
            <div  class="w-full xl:w-1/3" :class="(!form.thc_cbd_value_type || form.thc_cbd_value_type=='single')?'':'hidden'">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="cbd" v-model.number="form.cbd">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">CBD</label>
                        <div v-if="editItem.complianceType && editItem.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                        <div v-else class="flex flex-row rounded bg-gray-black ">
                            <span class="mt-1 ml-2">{{form.concentration_unit}}</span>
                            <input @change="vm_modified(true)" v-model.number="form.cbd" name="cbd" placeholder="20.5" class="block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                        </div>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
            <!-- thc_cbd_value_type is not set or thc_cbd_value_type is range -->
            <div class="w-full xl:w-1/3" :class="(form.thc_cbd_value_type && form.thc_cbd_value_type=='range')?'':'hidden'">
                <div class="input-wrapper">
                    <label class="text-xs">CBD ({{form.concentration_unit}})</label>
                    <div class="flex">
                        <div class="relative w-full">
                            <Field v-slot="{field, errors, errorMessage}" name="cbd_min" v-model.number="form.cbd_min">
                                <div v-if="editItem.complianceType && editItem.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                <input v-else @change="vm_modified(true)" v-model.number="form.cbd_min" name="cbd_min" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                        <span class="flex mx-1 mt-4">
                            <svg width="5" height="3" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.61719 0.955078V2.5H0.754883V0.955078H4.61719Z" fill="white"/>
                            </svg>
                        </span>
                        <div class="relative w-full">
                            <Field v-slot="{field, errors, errorMessage}" name="cbd_max" v-model.number="form.cbd_max">
                                <div v-if="editItem.complianceType && editItem.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                <input v-else @change="vm_modified(true)" v-model.number="form.cbd_max" name="cbd_max" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full flex xl:w-1/3">
                <div class="input-wrapper mr-3 w-full">
                    <Field v-slot="{field, errors, errorMessage}" name="totalTerp" v-model="form.totalTerp" >
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Terps</label>
                        <div v-if="editItem.complianceType && editItem.complianceType?.toLowerCase() === 'accessory'" class="flex flex-row capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                        <div v-else class="flex flex-row rounded bg-gray-black ">
                            <span class="mt-1 ml-2">%</span>
                            <input @change="vm_modified(true)" v-model="form.totalTerp" :onkeypress="preventNonNumbersAndDecimal" name="totalTerp" placeholder="4.0" min="0" class="block tracking-wider border-none focus:ring-0 rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="number">
                        </div>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
        </div>
        <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <Field v-model="form.sku" v-slot="{field, errors, errorMessage}" name="sku" >
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">SKU</label>
                        <input :disabled="asn?.sku" @change="vm_modified(true)" v-bind="field" placeholder="GJFKD2342" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <label class="text-xs">GTIN/barcode</label>
                    <input @change="vm_modified(true)" v-model="form.barcode" name="barcode" maxlength="16" placeholder="00043423322" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                </div>
            </div>
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <label class="text-xs">Case Size</label>
                    <input @change="vm_modified(true)" v-model="form.caseSize" name="caseSize" maxlength="16" placeholder="4" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                </div>
            </div>
        </div>
        <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <Field v-slot="{field}" name="fulfillmentTime" v-model="form.fulfillmentTime" >
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Fulfillment Time</label>
                        <div class="flex flex-row rounded bg-gray-black ">
                            <input @change="vm_modified(true)" v-model="form.fulfillmentTime" :onkeypress="preventNonNumbersAndDecimal" min="0" @paste.prevent placeholder="4.0" name="fulfillmentTime" class="block tracking-wider border-none focus:ring-0 rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="number">
                            <span class="text-sm self-center mr-2">Days</span>
                        </div>
                    </Field>
                </div>
            </div>
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper"> <!--  v-if="!allLotDisabled"-->
                    <Field v-slot="{field, errors, errorMessage}" name="reservedQty" v-model="form.reservedQty" >
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Reserved Stock</label>
                        <input @change="vm_modified(true)" readonly v-bind="field" placeholder="[X]" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="number">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
            <div class="flex gap-2 w-full xl:w-1/3">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="stock" v-model="form.stock" >
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Units In Stock</label>
                        <input @change="vm_modified(true)" readonly v-bind="field" placeholder="[X]" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="number">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
                <div class="input-wrapper"> <!--  v-if="!allLotDisabled"-->
                    <Field v-slot="{field, errors, errorMessage}" name="activeStock" v-model="form.activeStock" >
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Active Stock</label>
                        <input @change="vm_modified(true)" readonly v-bind="field" placeholder="[X]" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="number">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
        </div>
        <price-warning-modal v-if="priceWarning.modal" :title="priceWarning.title" :data="priceWarning.data" @close="closePriceWarningModal" @apply="save" />
        <LotAsn v-if="asn?.sku && editVariant.lotTracking && editItem.globalLotTracking" :editVariant="editVariant" :asn="asn" :productCbdThcType="form.thc_cbd_value_type" @changeLot="changeLot" />

    </Form>
</template>
<script>
import Helpers from '@/helpers';
import StringHelper from '@/helpers/string'
import ObjectHelper from '@/helpers/object'
import ProductHelper from '@/helpers/product'
import {mapGetters, mapMutations} from 'vuex'
import { ref, defineComponent } from 'vue'
import {Form, Field} from 'vee-validate'
import ProductApi from '@/controllers/BusinessProductApis'
import PricingGroupApis from "@/controllers/PricingGroup";
import { useSnackbar } from "vue3-snackbar"
import pick from 'lodash/pick'
import isEmpty from 'lodash/isEmpty'
import lowerCase from 'lodash/lowerCase'
import PriceMarkupSettingApis from "@/controllers/LocationMarkupPrice";
import LotAsn from './lot-asn.vue'

export default defineComponent({
    props: ['asn', 'fulfillment', 'globalExemptScanner', 'editItem', 'pricing', 'editVariant', 'cannabisProfile'],
    components: {
        Form,
        Field,
        LotAsn
    },
    setup() {
        const snackbar = useSnackbar();
        const loaded = ref(false)
        const variantProductDetail = ref({})
        const variantPricing = ref({})
        const cannabisProfile = ref({})
        const form = ref({
            variantName: '',
            dryCannabisEquivalency: '',
            thc_cbd_value_type: 'single',
            cost: '',
            price: '',
            sale_price: '',
            onlineSalePrice: '',
            sku: '',
            barcode: '',
            thc: '',
            thc_min: '',
            thc_max: '',
            cbd: '',
            cbd_min: '',
            cbd_max: '',
            stock: '',
            stock_threshold: '',
            reservedQty: '',
            concentration_unit: '',
            totalTerp: '',
            fulfillmentTime: '',
            activeStock: '',
            reservedQty:'',
            caseSize: '',
            lotTracking: false,
            exemptFromScanning: false
        })
        const schema = {
            sku: 'required|min:3|max:100',
            variantName: 'required',
            dryCannabisEquivalency: 'price'
        }
        const locationSchema = {
            variantName: 'required',
            dryCannabisEquivalency: 'required|price',
            price: 'required|price',
            cost: 'required|price',
            sale_price: 'price|saleGreaterThanRegular:price',
            onlineSalePrice: 'price|saleGreaterThanRegular:price',
            sku: 'required|min:3|max:100',
            thc: 'price',
            thc_min: 'price',
            thc_max: 'price',
            cbd: 'price',
            cbd_min: 'price',
            cbd_max: 'price',
            totalTerp: 'percentage',
            stock: 'positiveInteger'
        }
        const locationAccessorySchema = {
            variantName: 'required',
            dryCannabisEquivalency: 'price',
            price: 'required|price',
            cost: 'required|price',
            sale_price: 'price|saleGreaterThanRegular:price',
            onlineSalePrice: 'price|saleGreaterThanRegular:price',
            sku: 'required|min:3|max:100',
        }
        const cbdValueTypes = ['single', 'range']
        const asnForm = {}
        const lotList = ref([])
        const markupPrices = ref([])
        const markupPercent = ref('')
        const markupType = ref('')
        const prevFulfillmentTime = ref(null)
        // price warning modal
        const priceWarning = ref({
            modal: false,
            title: '',
            data: []
        })
        const regularPriceEdited = ref(false)
        // permission
        const showPermissionWarning = ref(false)
        const havePricingGroup = ref(false)
        const memoryPrice = ref(null)

        return {snackbar, loaded, variantProductDetail, variantPricing, cannabisProfile, form, schema, locationSchema, locationAccessorySchema, cbdValueTypes, asnForm, lotList, markupPrices, markupPercent, markupType, prevFulfillmentTime, priceWarning, regularPriceEdited, showPermissionWarning, havePricingGroup, memoryPrice}
    },
    async mounted(){
        await Promise.all([this.getMarkupPrices(), this.getPriceGroup()])
        // first click variant
        this.variantProductDetail = {...this.editVariant}
        this.form = pick(this.editVariant, ['variantName', 'dryCannabisEquivalency', 'thc_cbd_value_type', 'barcode', 'sku','caseSize', 'lotTracking', 'exemptFromScanning'])
        this.form.concentration_unit = this.editItem.concentration_unit
        if(this.vg_selectedLocation.id){
            this.vm_spinner(true)
            await this.getVariantPricing(this.editVariant.id)
            if(this.form.barcode=='unknown'){
                this.form.barcode = ''
            }
            if(this.editVariant?.complianceType?.toLowerCase()==='accessory' && this.asn){
                this.form.cost = this.variantPricing.cost?this.variantPricing.cost:(this.asn.cost?this.asn.cost:'')
                this.form.price = this.variantPricing.price?this.variantPricing.price:this.calculatePrice(this.asn.cost)
                this.form.sale_price = StringHelper.undefinedToNull(this.variantPricing.sale_price)
                this.form.onlineSalePrice = StringHelper.undefinedToNull(this.variantPricing.onlineSalePrice)
                this.form.stock = StringHelper.undefinedToEmptyString(this.variantPricing.stock)
                this.form.activeStock = StringHelper.undefinedToEmptyString(this.variantPricing.activeStock)
                this.form.reservedQty = StringHelper.undefinedToEmptyString(this.variantPricing.reservedQty)
            }else if(!isEmpty(this.variantPricing)){
                this.form.cost = this.variantPricing.cost?this.variantPricing.cost:''
                this.form.price = this.variantPricing.price
                this.form.sale_price = StringHelper.undefinedToNull(this.variantPricing.sale_price)
                this.form.onlineSalePrice = StringHelper.undefinedToNull(this.variantPricing.onlineSalePrice)
                this.form.stock = StringHelper.undefinedToEmptyString(this.variantPricing.stock)
                this.form.activeStock = StringHelper.undefinedToEmptyString(this.variantPricing.activeStock)
                this.form.reservedQty = StringHelper.undefinedToEmptyString(this.variantPricing.reservedQty)
            }else if(!isEmpty(this.asn)){
                this.form.cost = this.asn.cost?this.asn.cost:''
                let price = this.calculatePrice(this.asn.cost)
                this.form.price = price
                this.form.sale_price = price
                this.form.stock = ''
                this.form.activeStock = '',
                this.form.reservedQty = ''
            }else{
                this.form.cost = ''
                this.form.price = ''
                this.form.sale_price = ''
                this.form.onlineSalePrice = ''
                this.form.stock = ''
                this.form.activeStock = '',
                this.form.reservedQty = ''
            }
            await this.getCannabisProfile(this.editVariant.id)
            this.emitter.emit('changeThcCbdType', this.cannabisProfile.thc_cbd_value_type)
            this.memoryPrice = ''+this.form.price
            this.form.thc_cbd_value_type = StringHelper.undefinedToDefault(this.cannabisProfile.thc_cbd_value_type, 'single')
            this.form.thc = StringHelper.undefinedToEmptyString(this.cannabisProfile.thc)
            this.form.thc_min = StringHelper.undefinedToEmptyString(this.cannabisProfile.thc_min)
            this.form.thc_max = StringHelper.undefinedToEmptyString(this.cannabisProfile.thc_max)
            this.form.cbd = StringHelper.undefinedToEmptyString(this.cannabisProfile.cbd)
            this.form.cbd_min = StringHelper.undefinedToEmptyString(this.cannabisProfile.cbd_min)
            this.form.cbd_max = StringHelper.undefinedToEmptyString(this.cannabisProfile.cbd_max)
            this.form.totalTerp = StringHelper.undefinedToEmptyString(this.cannabisProfile.totalTerp)
            // for asn upload
            if(!isEmpty(this.asn)){
                this.form.caseSize = this.asn.packSize
                if(this.asn.thc || this.asn.thc===0) this.form.thc = StringHelper.undefinedToEmptyString(this.asn.thc)
                if(this.asn.thc_min || this.asn.thc_min===0) this.form.thc_min = StringHelper.undefinedToEmptyString(this.asn.thcMin)
                if(this.asn.thc_max || this.asn.thc_max===0) this.form.thc_max = StringHelper.undefinedToEmptyString(this.asn.thcMax)
                if(this.asn.cbd || this.asn.cbd===0) this.form.cbd = StringHelper.undefinedToEmptyString(this.asn.cbd)
                if(this.asn.cbd_min || this.asn.cbd_min===0) this.form.cbd_min = StringHelper.undefinedToEmptyString(this.asn.cbdMin)
                if(this.asn.cbd_max || this.asn.cbd_max===0) this.form.cbd_max = StringHelper.undefinedToEmptyString(this.asn.cbdMax)
                if(this.asn.totalTerp || this.asn.totalTerp===0) this.form.totalTerp = StringHelper.undefinedToEmptyString(this.asn.totalTerp)
            }
            if(this.fulfillment){
                this.form.fulfillmentTime = this.fulfillment
            }else{
                await this.getFulfillment(this.editVariant.id)
            }
            let lotParams = {locationId: this.vg_selectedLocation.id, productId: this.editVariant.id, gtin: null, lotOrder: 'desc'}
            let res = await ProductApi.fetchLotByProductId(lotParams)
            if(res.data?.payload?.batchUploadDetails){
                this.lotList = res.data.payload.batchUploadDetails
            }
            this.vm_spinner(false)
        }
        this.emitter.on("reloadEditVariant", this.reload)
        this.emitter.on("reloadEditCannabis", this.reloadCannabis)
        this.emitter.on("updateLotTracking", this.updateLotTracking);
        this.emitter.on("updateExemptScanning", this.updateExemptScanning);
        this.emitter.on("saveEditProduct", this.validateAndCheckForWarning);
    },
    unmounted(){
        this.emitter.off("reloadEditVariant", this.reload)
        this.emitter.off("reloadEditCannabis", this.reloadCannabis)
        this.emitter.off("updateLotTracking", this.updateLotTracking);
        this.emitter.off("updateExemptScanning", this.updateExemptScanning);
        this.emitter.off("saveEditProduct", this.validateAndCheckForWarning)
    },
    beforeDestroy() {
        this.emitter.off("reloadEditVariant", this.reload)
        this.emitter.off("reloadEditCannabis", this.reloadCannabis)
        this.emitter.off("updateLotTracking", this.updateLotTracking);
        this.emitter.off("updateExemptScanning", this.updateExemptScanning);
        this.emitter.off("saveEditProduct", this.validateAndCheckForWarning)
    },
    watch: {
        // switch variant
        async editVariant(variant){
            this.reload(variant)
        },
        'form.thc_cbd_value_type'(){
            this.emitter.emit('changeThcCbdType', this.form.thc_cbd_value_type)
        },
        'variantPricing.stock'(val){
            this.form.stock = val
        },
        'variantPricing.reservedQty'(val){
            this.form.reservedQty = val
        },
        'variantPricing.activeStock'(val){
            this.form.activeStock = val
        },
        'form.cost'(val){
            this.getMarkupPercent()
        },
        'form.price'(val){
            this.getMarkupPercent()
        },
        form:{
            handler: function(){
                if(this.loaded){
                    this.vm_modified(true)
                }
            },
            deep: true,
        },
        
    },
    computed: {
        /**
         * Manage change role
         */
         can_manage_pricing_groups() {
            return Helpers.getMyPermission('can_manage_pricing_groups')
        },
        can_edit_product_sale_price_and_inventory() {
            return Helpers.getMyPermission('can_edit_product_sale_price_and_inventory')
        },
        allLotDisabled: function(){
            if(this.lotList.every(each => !each.badge_running)){
                return true
            }else{
                return false
            }
        },
        ...mapGetters({
            vg_selectedBusiness: 'auth/activeBusiness',
            vg_selectedLocation: 'location/selected'
        })
    },
    methods: {
        // permission
        togglePermissionWarning(){
            this.showPermissionWarning = !this.showPermissionWarning
        },

        getSchema(){
            if(this.vg_selectedLocation.id){
                if(this.editItem.complianceType?.toLowerCase()=='accessory'){
                    return this.locationAccessorySchema
                }else{
                    return this.locationSchema
                }
            }else{
                return this.schema
            }
        },
        getMarkupPercent(){
            let result =  ProductHelper.saleMarginMarkup(this.form.price, this.form.cost, this.markupType)
            this.markupPercent = result
        },
        showPriceChangeWarning(){
            this.regularPriceEdited = true
        },
        async getPriceGroup(){
            let res = await PricingGroupApis.priceWarning(this.vg_selectedLocation.id)
            if(res.status==200 && res.data.payload && res.data.payload.groupLocations.length>0){
                this.havePricingGroup = true
            }else{
                this.havePricingGroup = false
            }
        },
        async getMarkupPrices(){
            let res = await PriceMarkupSettingApis.fetchByLocationId(this.vg_selectedLocation.id)
            if(this.asn){
                this.markupPrices = ObjectHelper.getDefaultMarkup(res?.data?.payload)
                if(this.editItem.complianceType){
                    let currentMarkupPrice = this.markupPrices.find(each => each.complianceType?.toLowerCase()===lowerCase(this.editItem.complianceType.replace(/\s/gi, '')))
                    if(currentMarkupPrice?.markupType){
                        this.markupType = currentMarkupPrice.markupType
                    }
                }
            }else{
                if(res.status==200){
                    this.markupPrices = res.data.payload
                    if(this.editItem.complianceType){
                        let currentMarkupPrice = this.markupPrices.find(each => each.complianceType?.toLowerCase()===lowerCase(this.editItem.complianceType.replace(/\s/gi, '')))
                        if(currentMarkupPrice?.markupType){
                            this.markupType = currentMarkupPrice.markupType
                        }
                    }
                }
            }
        },
        calculatePrice(val){
            if(this.editItem.complianceType){
                let currentMarkupPrice = this.markupPrices.find(each => each.complianceType?.toLowerCase()===lowerCase(this.editItem.complianceType?.replace(/\s/gi, '')))
                if(currentMarkupPrice && currentMarkupPrice.status && currentMarkupPrice?.markupPercentage){
                    let value = parseFloat(val)
                    this.currentMarkupPrice = parseInt(currentMarkupPrice?.markupPercentage)
                    this.markupType = currentMarkupPrice?.markupType
                    let result = 0
                    let decimal = 0
                    if(currentMarkupPrice?.markupType==='margin'){
                        let marginVal = 1-this.currentMarkupPrice/100
                        result = parseFloat(value)/marginVal
                        return result?result.toFixed(2):''
                    }else{
                        result = parseFloat(value)+(val*this.currentMarkupPrice/100)
                        decimal = (result%1).toFixed(2)
                        if(decimal>0){
                            return result?+parseInt(result)+0.99:''
                        }else{
                            return result?+result.toFixed(2):''
                        }
                    }
                }else if(this.asn){
                    return this.asn.cost
                }else{
                    return ''
                }
            }else if(this.asn){
                return this.asn.cost
            }else{
                return ''
            }
        },
        async reload(variant){
            this.variantProductDetail = {...variant}
            this.form = pick(variant, ['variantName', 'dryCannabisEquivalency', 'thc_cbd_value_type', 'barcode', 'sku','caseSize', 'exemptFromScanning'])
            this.form.concentration_unit = this.editItem.concentration_unit
            if(this.vg_selectedLocation.id){
                this.vm_spinner(true)
                await this.getVariantPricing(this.editVariant.id)
                if(this.form.barcode=='unknown'){
                    this.form.barcode = ''
                }
                if(!isEmpty(this.variantPricing)){
                    this.form.cost = this.variantPricing.cost?this.variantPricing.cost:''
                    this.form.price = this.variantPricing.price
                    this.form.sale_price = this.variantPricing.sale_price
                    this.form.onlineSalePrice = StringHelper.undefinedToNull(this.variantPricing.onlineSalePrice)
                    this.form.stock = StringHelper.undefinedToEmptyString(this.variantPricing.stock)
                    this.form.activeStock = StringHelper.undefinedToEmptyString(this.variantPricing.activeStock)
                    this.form.reservedQty = StringHelper.undefinedToEmptyString(this.variantPricing.reservedQty)
                }else if(!isEmpty(this.asn)){
                    this.form.cost = this.asn.cost
                    let price = this.calculatePrice(this.asn.cost)
                    this.form.price = price
                    this.form.sale_price = price
                    this.form.stock = ''
                    this.form.activeStock = '',
                    this.form.reservedQty = ''
                }else{
                    this.form.cost = ''
                    this.form.price = ''
                    this.form.sale_price = ''
                    this.form.onlineSalePrice = ''
                    this.form.stock = ''
                    this.form.activeStock = '',
                    this.form.reservedQty = ''
                }
                await this.getCannabisProfile(this.editVariant.id)
                this.memoryPrice = ''+this.form.price
                this.form.thc_cbd_value_type = this.cannabisProfile.thc_cbd_value_type
                this.form.thc_cbd_value_type = this.cannabisProfile.thc_cbd_value_type
                this.form.thc = StringHelper.undefinedToEmptyString(this.cannabisProfile.thc)
                this.form.thc_min = StringHelper.undefinedToEmptyString(this.cannabisProfile.thc_min)
                this.form.thc_max = StringHelper.undefinedToEmptyString(this.cannabisProfile.thc_max)
                this.form.cbd = StringHelper.undefinedToEmptyString(this.cannabisProfile.cbd)
                this.form.cbd_min = StringHelper.undefinedToEmptyString(this.cannabisProfile.cbd_min)
                this.form.cbd_max = StringHelper.undefinedToEmptyString(this.cannabisProfile.cbd_max)
                this.form.totalTerp = StringHelper.undefinedToEmptyString(this.cannabisProfile.totalTerp)
                // for asn upload
                if(!isEmpty(this.asn)){
                    this.form.caseSize = this.asn.packSize
                }
                if(isEmpty(this.cannabisProfile) && !isEmpty(this.asnForm)){
                    if(this.asn.thc || this.asn.thc===0) this.form.thc = this.asnForm.thc
                    if(this.asn.thc_min || this.asn.thc_min===0) this.form.thc_min = this.asnForm.thcMin?this.asnForm.thcMin:''
                    if(this.asn.thc_max || this.asn.thc_max===0) this.form.thc_max = this.asnForm.thcMax?this.asnForm.thcMax:''
                    if(this.asn.cbd || this.asn.cbd===0) this.form.cbd = this.asnForm.cbd?this.asnForm.cbd:''
                    if(this.asn.cbd_min || this.asn.cbd_min===0) this.form.cbd_min = this.asnForm.cbdMin?this.asnForm.cbdMin:''
                    if(this.asn.cbd_max || this.asn.cbd_max===0) this.form.cbd_max = this.asnForm.cbdMax?this.asnForm.cbdMax:''
                    if(this.asn.totalTerp || this.asn.totalTerp===0) this.form.totalTerp = this.asnForm.totalTerp?this.asnForm.totalTerp:''
                }
                if(this.fulfillment){
                    this.form.fulfillmentTime = this.fulfillment
                }else{
                    await this.getFulfillment(this.editVariant.id)
                }
                let lotParams = {locationId: this.vg_selectedLocation.id, productId: this.editVariant.id, gtin: null, lotOrder: 'desc'}
                let res = await ProductApi.fetchLotByProductId(lotParams)
                if(res.data?.payload?.batchUploadDetails){
                    this.lotList = res.data.payload.batchUploadDetails
                }
                this.vm_spinner(false)
            }
        },
        async reloadCannabis(){
            if(this.vg_selectedLocation.id){
                await this.getCannabisProfile(this.editVariant.id)
                this.form.thc = StringHelper.undefinedToEmptyString(this.cannabisProfile.thc)
                this.form.thc_min = StringHelper.undefinedToEmptyString(this.cannabisProfile.thc_min)
                this.form.thc_max = StringHelper.undefinedToEmptyString(this.cannabisProfile.thc_max)
                this.form.cbd = StringHelper.undefinedToEmptyString(this.cannabisProfile.cbd)
                this.form.cbd_min = StringHelper.undefinedToEmptyString(this.cannabisProfile.cbd_min)
                this.form.cbd_max = StringHelper.undefinedToEmptyString(this.cannabisProfile.cbd_max)
                this.form.totalTerp = StringHelper.undefinedToEmptyString(this.cannabisProfile.totalTerp)
            }
        },
        updateLotTracking(val){
            this.form.lotTracking = val
        },
        updateExemptScanning(val){
            this.form.exemptFromScanning = val
            this.vm_modified(true)
        },
        labelClass(value, error){
            if(value && error){
                return 'text-theme-red'
            }else if(error){
                return 'text-theme-orange'
            }else if(value){
                return 'text-theme-green'
            }
        },
        inputClass(value, error){
            if(value && error){
                return 'border-theme-red'
            }else if(error){
                return 'border-theme-orange'
            }else if(value){
                return 'border-theme-green'
            }
        },
        errorClass(value, error){
            if(value && error){
                return 'text-theme-red'
            }else if(error){
                return 'text-theme-orange'
            }
        },
        calculateSaleMarkupMargin(type='sale'){
            let result
            // if markup setting and compliance type selected
            let salePrice = type==='sale'?this.form.sale_price:this.form.onlineSalePrice
            if(salePrice){
                if(this.markupPrices && this.editItem.complianceType){
                    let currentMarkupPrice = this.markupPrices.find(each => each.complianceType?.toLowerCase()===lowerCase(this.editItem.complianceType.replace(/\s/gi, '')))
                    if(currentMarkupPrice){
                        result =  ProductHelper.saleMarginMarkup(salePrice, this.form.cost, currentMarkupPrice.markupType)
                    }else{
                        result =  ProductHelper.saleMarginMarkup(salePrice, this.form.cost, 'markup')
                    }
                }else{
                    // default markup calculation
                    result =  ProductHelper.saleMarginMarkup(salePrice, this.form.cost, 'markup')
                }
            }
            return result
        },
        discountPercent(){
            if(this.form.sale_price && this.form.price){
                return Math.round(((this.form.price-this.form.sale_price)/this.form.price*100))
            }else{
                return ''
            }
        },
        changeLot(form){
            this.asnForm = form
        },
        async getVariantPricing(productId){
            let data = {locationId: this.vg_selectedLocation.id, productIds:[productId]}
            let res = await ProductApi.fetchPricingByProductId(data)
            if(res.data?.payload[0]){
                this.variantPricing = res.data.payload[0]
                // update variant lot count
                this.emitter.emit('updateVariantLotCount', this.variantPricing.stock)
            }else{
                this.variantPricing = {}
                // update variant lot count
                this.emitter.emit('updateVariantLotCount', 0)
            }
        },
        async getCannabisProfile(productId){
            let res = await ProductApi.fetchCannabisProfile(productId, this.vg_selectedLocation.id)
            if(res.data?.payload){
                this.cannabisProfile = res.data.payload
            }else{
                this.cannabisProfile = {}
            }
        },
        async getFulfillment(productId){
            let res = await ProductApi.getFulfillmentByProductId(productId)
            if(res.data?.payload && res.data.payload.length>0){
                this.form.fulfillmentTime = res.data.payload[res.data.payload.length-1]?.fullfillmentTime
                this.prevFulfillmentTime = res.data.payload[res.data.payload.length-1]?.fullfillmentTime
            }else{
                this.form.fulfillmentTime = null
            }
        },
        showPriceChangeWarning(){
            this.regularPriceEdited = true
        },
        closePriceWarningModal(){
            this.priceWarning.modal = false
        },
        async validateAndCheckForWarning(){
            let validationResult = await this.$refs.defaultForm?.validate()
            let hasBatchLot = true
            let hasPackagedOn = true
            // check for batch lot and package date only for asn 
            if(this.asn?.sku && this.variantProductDetail.globalLotTracking && this.variantProductDetail.lotTracking){
                if(!this.asnForm.batch_lot){
                    this.snackbar.add({
                        type: 'info',
                        text: "Batch lot is required",
                        duration: 3000,
                    })
                    hasBatchLot = false
                }
                if(!this.asnForm.packaged_on){
                    this.snackbar.add({
                        type: 'info',
                        text: "Packaged date is required",
                        duration: 3000,
                    })
                    hasPackagedOn = false
                }
            }
            
            if(validationResult?.valid && hasBatchLot && hasPackagedOn){
                if(this.regularPriceEdited && this.can_manage_pricing_groups){
                    this.vm_spinner(true);
                    let res = await PricingGroupApis.priceWarning(this.vg_selectedLocation.id)
                    if(res.status==200 && res.data.payload && res.data.payload.groupLocations.length>0){
                        this.priceWarning = {
                            modal: true,
                            title: 'This pricing change will affect the following locations:',
                            data: res.data.payload,
                        }
                        this.vm_spinner(false);
                    }else{
                        await this.save()
                    }
                }else{
                    await this.save()
                }
            }
        },
        async save(){ 
            this.vm_spinner(true)
            this.priceWarning.modal = false
            let res = null
            if(this.asn?.sku){
                res = await this.asnEditVariant()
            }else{
                res = await this.editTheVariant()
            }
            if(res){
                this.snackbar.add({
                    type: 'info',
                    text: (res.status == 200 || res.status == 201) ? "Product variant updated successfully." : Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })
            }
            this.vm_spinner(false)
            if(res?.status==200 || res?.status == 201){
                if(this.asn?.sku){
                    this.vm_modified(false)
                    this.emitter.emit("reloadAddAsnList")
                    this.emitter.emit('closeAddEditInPurchaseOrder')
                }else{
                    this.vm_modified(false)
                    this.variantProductDetail = ObjectHelper.pickWithDefault(this.form, ['variantName', 'dryCannabisEquivalency', 'barcode', 'sku'], [null, null, null, null])
                    this.variantPricing = ObjectHelper.pickWithDefault(this.form, ['price', 'sale_price', 'cost'], [null, null, null])
                    this.cannabisProfile = ObjectHelper.pickWithDefault(this.form, ['cbd','cbd_max','cbd_min','thc','thc_max','thc_min','thc_cbd_value_type','totalTerp'], [null, null, null, null, null, null, 'single',null])
                    this.emitter.emit('changeThcCbdType', this.form.thc_cbd_value_type)
                    this.emitter.emit('reloadProduct', this.editItem.id)
                    this.emitter.emit("reloadProductList", this.editItem.id)
                    this.getVariantPricing(this.editVariant.id)
                }
            }
            
        },
        async editTheVariant(){
            // product data       
            let productData = pick(this.editItem, ['name','sku','barcode','variantName','businessId','categoryId','brandId','description','longDescription','productFamily','complianceType','sort','dryCannabisEquivalency','featured','retired','strain','product_form','concentration_unit','thc_cbd_value_type','thc','thc_min','thc_max','cbd','cbd_min','cbd_max','caseSize'])
            productData = {...productData, ...this.form}
            // add parentProductId only if not main variant
            if(productData.barcode===''){
                productData.barcode = null
            }
            if(this.editItem.id!==this.editVariant.id){
                productData.parentProductId = this.editItem.id
            }
            let res = null
            let productObjSame = ObjectHelper.compareObjects(this.variantProductDetail, this.form, ['variantName', 'dryCannabisEquivalency', 'barcode', 'sku','caseSize', 'exemptFromScanning'])
            if(!productObjSame){
                res = await ProductApi.editProduct(this.editVariant.id, productData)
                if(res?.response?.status==400){
                    return res
                }
            }

            if(this.vg_selectedLocation.id){
                // pricing data
                if(!this.form.sale_price) this.form.sale_price = this.form.price
                let productPricingData = {
                    locationId: this.vg_selectedLocation.id,
                    cost: parseFloat(this.form.cost),
                    price:  parseFloat(this.form.price),
                    sale_price: parseFloat(this.form.sale_price),
                    onlineSalePrice: parseFloat(this.form.onlineSalePrice),
                    stock: parseInt(this.form.stock) || 0,
                    activeStock: parseInt(this.form.activeStock) || 0,
                    reservedQty: parseInt(this.form.reservedQty) || 0
                }
                productPricingData.productId = this.editVariant.id
                if(this.variantPricing.id){
                    let PricingObjSame = ObjectHelper.compareObjects(this.variantPricing, this.form, ['price', 'sale_price', 'cost', 'onlineSalePrice'])
                    if(!PricingObjSame){
                        res = await ProductApi.updateProductPricing(this.variantPricing.id, productPricingData)
                    }
                }else{
                    res = await ProductApi.createProductPricing(productPricingData)
                }

                // cannabis profile
                let cannabisProfileData = {
                    locationId: this.vg_selectedLocation.id,
                    thc_cbd_value_type: this.form.thc_cbd_value_type?this.form.thc_cbd_value_type:'single',
                    thc: parseFloat(this.form.thc),
                    cbd: parseFloat(this.form.cbd),
                    thc_min: parseFloat(this.form.thc_min),
                    thc_max: parseFloat(this.form.thc_max),
                    cbd_min: parseFloat(this.form.cbd_min),
                    cbd_max: parseFloat(this.form.cbd_max),
                    totalTerp: parseFloat(this.form.totalTerp),
                    fullfillmentTime: parseInt(this.form.fulfillmentTime)
                }
                // create or update
                let prevObj = {...this.cannabisProfile, fullfillmentTime: this.prevFulfillmentTime}
                let CannabisObjSame = ObjectHelper.compareObjects(prevObj, cannabisProfileData, ['cbd','cbd_max','cbd_min','thc','thc_max','thc_min','thc_cbd_value_type','totalTerp', 'fullfillmentTime'])
                if(!CannabisObjSame){
                    res = await ProductApi.updateCannabisProfile(this.editVariant.id, cannabisProfileData)
                }
                return res
            }
            // create batch if from asn
            if(this.asn?.sku){
                await ProductApi.createProductBatch()
            }
        },
        async asnEditVariant(){
            let data = {
                product:{
                    name:this.asn.name,
                    locationId:this.vg_selectedLocation.id,
                    categoryId:this.editItem.categoryId,
                    brandId:this.editItem.brandId,
                    description:this.editItem.description?this.editItem.description:(this.asn?.masterProduct?.description?this.asn?.masterProduct?.description:''),
                    longDescription: this.editItem.longDescription?this.editItem.longDescription:(this.asn?.masterProduct?.longDescription?this.asn?.masterProduct?.longDescription:''),
                    productFamily:this.editItem.productFamily,
                    complianceType:this.editItem.complianceType,
                    strain:this.editItem.strain,
                    concentration_unit:this.form.concentration_unit,
                    supplierId:this.form.supplierId,
                    parentProductId:this.form.parentProductId,
                    sku:this.form.sku,
                    barcode:this.form.barcode,
                    variantName:this.form.variantName,
                    dryCannabisEquivalency:this.form.dryCannabisEquivalency,
                    retired:this.editItem.retired,
                    lotTracking:this.form.lotTracking,
                    exemptFromScanning: this.form.exemptFromScanning,
                    caseSize:this.form.caseSize,
                    licensedProducer:this.editItem.producer?.licensedProducer,
                    purchaseOrderItemId:this.asn.id
                },
                pricing: {
                    locationId:this.vg_selectedLocation.id,
                    price:this.form.price,
                    sale_price:this.form.sale_price,
                    onlineSalePrice: this.form.onlineSalePrice,
                    cost:this.form.cost,
                    stock:this.form.stock,
                    activeStock:this.form.activeStock
                }, 
                cannabisProfile: {
                    locationId:this.vg_selectedLocation.id,
                    thc: parseFloat(this.form.thc),
                    cbd: parseFloat(this.form.cbd),
                    thc_min: parseFloat(this.form.thc_min),
                    thc_max: parseFloat(this.form.thc_max),
                    cbd_min: parseFloat(this.form.cbd_min),
                    cbd_max: parseFloat(this.form.cbd_max),
                    totalTerp: this.form.totalTerp ? parseFloat(this.form.totalTerp) : 0,
                    thc_cbd_value_type: this.form.thc_cbd_value_type,
                    fullfillmentTime: parseInt(this.form.fulfillmentTime)
                }
            }
            if(this.editItem.lotTracking){
                data.batch = this.asnForm
                data.batch.totalTerp = this.asnForm.totalTerp ? parseFloat(this.asnForm.totalTerp) : 0
            }
            let res = await ProductApi.addOrUpdatePurchaseOrderItem(data)
            return res
        },
        preventNonNumbersAndDecimal(e) {
          var ASCIICode = (e.which) ? e.which : e.keyCode
          if(ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 101 || e.which == 8 || ASCIICode !== 46 && ASCIICode != 0 && (ASCIICode < 48 || ASCIICode > 57)){
            return false
          }
          return true;
        },
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner',
            vm_modified: 'modifiedForm/mutateStatus'
        })
    }
})
</script>